// TSP utility functions
import axios from 'axios';
import { TSP_SAVE_CUSTOM_PATH } from '../../../../config';

// Calculate distance between two points
const manhattanDistance = (lat1, lon1, lat2, lon2) => {
  // Convert degree differences to approximate kilometers
  const latDiff = Math.abs(lat2 - lat1);
  const lonDiff = Math.abs(lon2 - lon1);
  
  // Convert to kilometers using degree-to-km conversion
  const latKm = latDiff * 111.0;
  const lonKm = lonDiff * 111.0;
  
  // Manhattan distance in kilometers
  return latKm + lonKm;
};

// Calculate total path distance
export const calculatePathDistance = (path, locations) => {
  if (!path || !locations || path.length < 2) return 0;
  
  let totalDistance = 0;
  
  for (let i = 0; i < path.length - 1; i++) {
    const currentLocation = locations.find(loc => loc.id === path[i]);
    const nextLocation = locations.find(loc => loc.id === path[i + 1]);
    
    if (currentLocation && nextLocation) {
      totalDistance += manhattanDistance(
        currentLocation.latitude, currentLocation.longitude,
        nextLocation.latitude, nextLocation.longitude
      );
    }
  }
  
  return totalDistance;
};

// Save custom path
export const saveCustomPathToPermanent = async (path, distance) => {
  const requestData = { path, distance };
  
  console.log('TSP-API', 'Sending request to:', TSP_SAVE_CUSTOM_PATH);
  console.log('TSP-API', 'Request data:', requestData);
  
  const response = await axios.post(TSP_SAVE_CUSTOM_PATH, requestData);
  
  if (!response.data.success) {
    console.error('TSP path save failed:', response.data.error);
    throw new Error(response.data.error || 'Custom path save failed');
  }
  
  return response.data.data;
}; 